/**
 * @module industries
 * @description A list of industries
 */

export const industries = [
	'Accounting & Finance',
	'Advertising & Marketing',
	'Automotive',
	'Beauty & Personal Care',
	'Cleaning Services',
	'Home Services',
	'Construction & Renovation',
	'E-commerce & Retail',
	'Education & Training',
	'Event Planning & Management',
	'Fitness & Wellness',
	'Food & Beverage',
	'Healthcare & Medical',
	'Hospitality & Tourism',
	'Legal Services',
	'Real Estate',
	'Technology & IT Services',
	'Travel & Leisure',
	'Non-Profit & Charitable Organizations',
	'Professional Services',
	'Property Management',
	'Other',
] as const;
export type Industries = (typeof industries)[number];
